/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from 'vue';

require('../../js/front/bootstrap');
try {
  window.pushMessaging = require('./firebase').default;
} catch (e) {
  // console.error('This browser doesn\'t support the API\'s required to use the firebase SDK.');
  console.error(e.message);
}

import { store, router } from '../../js/front/vue_config';
import VueMixins from '../../js/front/vue_mixins';
import vuePushEventLog from '../../js/front/scripts/vuePushEventLog';

require('./vue_components');


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

window.vApp = new Vue({
  el: '#app',
  store,
  router,
  mixins: [VueMixins],
  methods: {
    showNotification(notification) {
      if (notification.displayAs === 'banner') {
        return;
      }

      if (notification.displayAs === 'modal') {
        this.$store.commit('notifications/addNotification', notification);
      } else {
        // turn off new message notification on chat page
        if (notification.type === 'App\\Notifications\\NewMessageNotification' && this.$route.name === 'chat') {
          return;
        }

        // show notification
        this.$notify({
          group: 'custom-template',
          type: notification.status,
          title: notification.title,
          text: notification.text,
          duration: -1,
          data: {
            avatar_url: notification.avatar_url,
            url: notification.url,
          },
        });

        // this.gtag('event', 'notification', {
        //   'event_category': notification.type,
        // });
      }
    },
    afterUserLoaded: function (userId) {

    },
  },
});

